import React from 'react';
import './AlgorithmsNeedingData.css';

export default function AlgorithmsNeedingData({ mode, algorithms, onSelect }) {
  if (!algorithms || algorithms.length === 0) return null;

  return (
    <div className="algorithms-needing-data">
      <h3>Algorithms Needing Practice</h3>
      <div className="alg-list">
        {algorithms.map((alg) => (
          <div key={alg.id} className="alg-item">
            <span>{alg.name}</span>
            <button onClick={() => onSelect([alg.id])}>Practice Now</button>
          </div>
        ))}
      </div>
    </div>
  );
} 